import apiClient from './apiClient';

export interface QueryParams {
  dateFrom?: string;
  dateTo?: string;
  deptFrom?: string;
  deptTo?: string;
  gradeFrom?: string;
  gradeTo?: string;
  deptLevel?: number;
}

export interface AnomalyRow {
  F912_01: string;   // employee number
  F912_02: string;   // attendance date (YYYY-MM-DD)
  F912_03: string;   // anomaly code / time
  F912_11: string;   // anomaly type: Q/V/P/Z
  F912_12: string;   // anomaly description memo
  F912_13: string;   // related document number
  F912_31: string;   // department code (truncated by DeptLevel)
  F901_11: string;   // employee name
  F901_37: string;   // position grade code
  dept_name: string; // department name
}

export interface QueryResponse {
  data: AnomalyRow[];
  count: number;
  message?: string;
}

export const pw9312Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9312/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9312/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
